import { ProductDetails } from './ProductDetails';
import { DISCUSSION_QUESTIONS, DiscussionType } from '~/lib/discussions/types';

export function Sidebar({
  deal,
  discussionSlug = DISCUSSION_QUESTIONS,
}: {
  deal: any;
  discussionSlug?: DiscussionType;
}) {
  return (
    <aside className="w-[400px] min-w-[400px] pb-8 max-sm:w-full max-sm:min-w-full">
      <ProductDetails deal={deal} discussionSlug={discussionSlug} />
    </aside>
  );
}
